<template>
  <header>
    <div class="inner">
      <a class="logo" href="/">
        <img alt="KP Wooden Gates" src="../assets/logo.jpg" />
      </a>
      <div class="right telephone" v-if="contact_info">
        <a :key="tel._id" href v-for="tel in contact_info.telephone_numbers">
          <span>{{tel.location}}</span>
          {{tel.number}}
        </a>
        <a href="mailto:info@wortleybrotherswoodengates.co.uk"><span><i class="fa fa-envelope"></i></span> Email Us</a>
      </div>
      <div class="right actions">
        <page-link :href="help_page.url" v-if="help_page">
          <i class="fa fa-question-circle-o"></i>
          {{help_page.name}}
        </page-link>
        <page-link :href="basket_page.url" v-if="basket_page">
          <i class="fa fa-shopping-cart"></i>
          {{basket_page.name}}
        </page-link>
      </div>
      <nav v-if="main_menu">
        <ul class="sf-menu">
          <template v-for="(page, index) in main_menu">
            <li :key="page.ItemID">
              <page-link :to="'/' + (page.url == 'default' ? '' : page.url)">{{page.name}}</page-link>
            </li>
            <li :key="page.ItemID + 'cats'" v-if="index == 0 && categories">
              <a href="#">Products</a>
              <ul>
                <li :key="category.ItemID" v-for="category in categories">
                  <page-link :to="'/' + category.url">{{category.name}}</page-link>
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex"
import { mapGetters } from "vuex"

export default {
  name: "Header",
  computed: {
    ...mapState(["misc", "contact_info", "categories", "help_page", "basket_page"]),
    ...mapGetters(["main_menu"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  display: block;
  float: left;
  padding: 1rem 0;
  line-height: 0;
}

.logo img {
  height: 120px;
}

.right {
  float: right;
}

.actions {
  border: 1px solid #f79322;
  margin-top: 2rem;
  line-height: 0;
}

.telephone {
  border: 1px solid #f79322;
  background: #f79322;
  margin-top: 2rem;
  line-height: 0;
}

.actions a,
.telephone a {
  display: inline-block;
  padding: 0.5rem 2rem;
  font-size: 1.3rem;
  line-height: 2rem;
}

.actions a i {
  color: #f79322;
  display: inline-block;
  margin-right: 1rem;
}

.telephone a {
  color: #fff;
  display: inline-block;
  padding: 0.5rem 1rem;
}

.telephone a span {
  color: #414e4f;
  display: inline-block;
  margin-right: 0.5rem;
}

.search input {
  border: 1px solid #dfdfdf;
  width: 30rem;
  padding: 1rem;
  margin: 6rem 0 0 0;
}

.search button {
  padding: 1rem;
  margin: 3rem 0 0 0;
  padding: 1rem;
  border: 0;
  background-color: #414e4f;
  color: #f79322;
  cursor: pointer;
}

header {
  background-color: #414e4f;
  clear: both;
  color: white;
  font-size: 2rem;
  z-index: 2;
  position: relative;
}

@media screen and (max-width: 1200px) {
  .logo img {
    height: 10rem;
  }
}

@media screen and (max-width: 950px) {
  nav {
    display: none;
  }

  .logo {
    padding-top: 0;
    margin-bottom: 1rem;
    margin-top: -2.5rem;
  }

  .telephone {
    margin-top: 1rem;
  }

  .actions {
    margin-top: 1rem;
    border: 0;
    clear: right;
  }

  .actions a {
    padding-right: 0;
  }
  header {
    padding-top: 2px;
  }
}

@media screen and (max-width: 560px) {
  .telephone {
    display: none;
  }
  .actions {
    margin-top: 0;
  }
  .logo {
    margin-bottom: 0.5rem;
  }
  .logo img {
    height: 7rem;
  }
}

/*** SF MENU ***/
.sf-menu,
.sf-menu * {
  margin: 0;
  padding: 0;
  list-style: none;
}
.sf-menu li {
  position: relative;
}
.sf-menu ul {
  position: absolute;
  display: none;
  top: 100%;
  left: 0;
  z-index: 99;
  text-align: left;
  -webkit-box-shadow: -2px 7px 11px 0px rgba(0, 0, 0, 0.38);
  -moz-box-shadow: -2px 7px 11px 0px rgba(0, 0, 0, 0.38);
  box-shadow: -2px 7px 11px 0px rgba(0, 0, 0, 0.38);
}
.sf-menu > li {
  float: left;
}
.sf-menu li:hover > ul,
.sf-menu li.sfHover > ul {
  display: block;
}

.sf-menu a {
  display: block;
  position: relative;
}
.sf-menu ul ul {
  top: 0;
  left: 100%;
}

/*** DEMO SKIN ***/
.sf-menu {
  float: right;
  clear: right;
  margin-top: 2rem;
}
.sf-menu ul {
  min-width: 12em; /* allow long menu items to determine submenu width */
  *width: 12em; /* no auto sub width for IE7, see white-space comment below */
}
.sf-menu a {
  padding: 0.3rem 2rem;
  text-decoration: none;
  zoom: 1; /* IE7 */
}

.sf-menu li {
  white-space: nowrap; /* no need for Supersubs plugin */
  *white-space: normal; /* ...unless you support IE7 (let it wrap) */
  -webkit-transition: background 0.2s;
  transition: background 0.2s;
}

.sf-menu li ul li {
  width: 100%;
}

.sf-menu > li > a {
  display: block;
}

.sf-menu ul li {
  background: #f79227;
}
.sf-menu ul ul li {
  background: rgba(255, 255, 255, 0.1);
}
.sf-menu li:hover,
.sf-menu li.sfHover {
  background: #f79227;
  /* only transition out, not in */
  -webkit-transition: none;
  transition: none;
}
.sf-menu li ul li:hover {
  background: rgb(243, 162, 76);
}

/*** arrows (for all except IE7) **/
.sf-arrows .sf-with-ul {
  padding-right: 2.5em;
  *padding-right: 1em; /* no CSS arrows for IE7 (lack pseudo-elements) */
}
/* styling for both css and generated arrows */
.sf-arrows .sf-with-ul:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 1em;
  margin-top: -3px;
  height: 0;
  width: 0;
  /* order of following 3 rules important for fallbacks to work */
  border: 5px solid transparent;
  border-top-color: #dfeeff; /* edit this to suit design (no rgba in IE8) */
  border-top-color: rgba(255, 255, 255, 0.5);
}
.sf-arrows > li > .sf-with-ul:focus:after,
.sf-arrows > li:hover > .sf-with-ul:after,
.sf-arrows > .sfHover > .sf-with-ul:after {
  border-top-color: white; /* IE8 fallback colour */
}
/* styling for right-facing arrows */
.sf-arrows ul .sf-with-ul:after {
  margin-top: -5px;
  margin-right: -3px;
  border-color: transparent;
  border-left-color: #dfeeff; /* edit this to suit design (no rgba in IE8) */
  border-left-color: rgba(255, 255, 255, 0.5);
}
.sf-arrows ul li > .sf-with-ul:focus:after,
.sf-arrows ul li:hover > .sf-with-ul:after,
.sf-arrows ul .sfHover > .sf-with-ul:after {
  border-left-color: white;
}
</style>
